const STRIPE_FEE_FIXED = 0.3
const STRIPE_FEE_PERCENT = 0.029

// https://support.stripe.com/questions/passing-the-stripe-fee-on-to-customers
const calculateStripeFee = amountInCents => {
  const pGoal = amountInCents / 100.0
  const pCharge = (pGoal + STRIPE_FEE_FIXED) / (1.0 - STRIPE_FEE_PERCENT)

  const processingFee = Math.round(pCharge * 100.0 - amountInCents)
  return processingFee
}

export default calculateStripeFee
